<template>
  <!-- .profile -->
  <div class="company-profile-page" :class="[{ 'no-margin-top': embedded, 'no-padding-top': embedded }]">
    <div class="container edit-user-template">
      <h1 class="page-header color-1-100" v-if="!embedded">
        <template v-if="canEditBillingContact">
          Edit billing profile
        </template>
        <template v-else>
          Billing profile
        </template>
      </h1>
      <div class="flex-block" :class="[{ 'no-margin-top': embedded, 'no-padding-top': embedded }]">
        <div class="content-right-section anchors">
          <div class="sticky-anchors background-1-40-before" tabindex="-1">
            <div class="anchor-item anchor-item-custom color-1-20 details"
                 v-if="currentPlan && currentPlan.plan"
                 :class="[{ 'active  color-1-100': activeSection === 'subscriptionDetails' }]">
              <a href="#" @click.prevent="goToPageSection('subscriptionDetails')">
                <span class="anchor-item-icon color-1-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="19.25" height="22" viewBox="0 0 19.25 22">
                    <path id="plan-summary" d="M16.5-19.25H2.75A2.75,2.75,0,0,0,0-16.5V0A2.75,2.75,0,0,0,2.75,2.75H16.5A2.75,2.75,0,0,0,19.25,0V-16.5A2.751,2.751,0,0,0,16.5-19.25ZM2.75-14.437a.694.694,0,0,1,.688-.687H4.813a.692.692,0,0,1,.688.688v1.375a.69.69,0,0,1-.687.688H3.438a.691.691,0,0,1-.687-.687ZM5.5-2.062a.69.69,0,0,1-.687.688H3.438a.691.691,0,0,1-.687-.687V-3.437a.694.694,0,0,1,.688-.687H4.813a.692.692,0,0,1,.688.688ZM7.017-9.483,4.611-7.077a.687.687,0,0,1-.486.2.689.689,0,0,1-.486-.2L2.608-8.108a.687.687,0,0,1,0-.972.687.687,0,0,1,.972,0l.545.547,1.92-1.92a.687.687,0,0,1,.972,0,.684.684,0,0,1,0,.971Zm8.8,7.421H8.937A.69.69,0,0,1,8.25-2.75a.689.689,0,0,1,.688-.687h6.875a.688.688,0,0,1,.688.688A.689.689,0,0,1,15.813-2.062Zm0-5.5H8.937A.69.69,0,0,1,8.25-8.25a.689.689,0,0,1,.688-.687h6.875a.69.69,0,0,1,.688.688A.69.69,0,0,1,15.813-7.562Zm0-5.5H8.937a.69.69,0,0,1-.687-.687.689.689,0,0,1,.688-.687h6.875a.69.69,0,0,1,.688.688A.69.69,0,0,1,15.813-13.062Z" transform="translate(0 19.25)" fill="currentColor"/>
                  </svg>
                </span>
                Plan summary
              </a>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 owner"
                 :class="[{ 'active  color-1-100': activeSection === 'billingContact' }]">
              <a href="#" @click.prevent="goToPageSection('billingContact')">
                <span class="anchor-item-icon color-1-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20.625" height="22" viewBox="0 0 20.625 22">
                    <path id="billing-contact" d="M16.5-19.25H4.125a2.75,2.75,0,0,0-2.75,2.75V0a2.75,2.75,0,0,0,2.75,2.75H16.5A2.75,2.75,0,0,0,19.25,0V-16.5A2.751,2.751,0,0,0,16.5-19.25Zm-6.187,5.5A2.75,2.75,0,0,1,13.063-11a2.75,2.75,0,0,1-2.75,2.75A2.75,2.75,0,0,1,7.563-11,2.751,2.751,0,0,1,10.313-13.75Zm4.125,11H6.188A.69.69,0,0,1,5.5-3.437,3.437,3.437,0,0,1,8.938-6.875h2.75a3.438,3.438,0,0,1,3.438,3.438A.69.69,0,0,1,14.438-2.75ZM21.313-16.5h-.687v4.125h.688A.69.69,0,0,0,22-13.062v-2.75A.688.688,0,0,0,21.313-16.5Zm0,5.5h-.687v4.125h.688A.69.69,0,0,0,22-7.562v-2.75A.69.69,0,0,0,21.313-11Zm0,5.5h-.687v4.125h.688A.688.688,0,0,0,22-2.062v-2.75A.69.69,0,0,0,21.313-5.5Z" transform="translate(-1.375 19.25)" fill="currentColor"/>
                  </svg>
                </span>
                <template v-if="canEditBillingContact === false">Billing contact</template>
                <template v-else>Edit billing contact</template>
              </a>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 owner"
                 :class="[{ 'active  color-1-100': activeSection === 'billingDetails' }]">
              <a href="#" @click.prevent="goToPageSection('billingDetails')">
                <span class="anchor-item-icon color-1-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24.75" height="19.25" viewBox="0 0 24.75 19.25">
                    <path id="billing-details" d="M22-17.875H2.75A2.75,2.75,0,0,0,0-15.125v13.75a2.75,2.75,0,0,0,2.75,2.75H22a2.75,2.75,0,0,0,2.75-2.75v-13.75A2.751,2.751,0,0,0,22-17.875ZM2.711-7.562A.687.687,0,0,1,3.4-8.25H7.524a.687.687,0,0,1,.688.688v1.375a.688.688,0,0,1-.687.688H3.4a.688.688,0,0,1-.687-.687V-7.562ZM6.875-1.719a.345.345,0,0,1-.344.344H3.094a.344.344,0,0,1-.344-.344v-.687a.344.344,0,0,1,.344-.344H6.531a.344.344,0,0,1,.344.344Zm8.25,0a.344.344,0,0,1-.344.344H8.594a.345.345,0,0,1-.344-.344v-.687a.344.344,0,0,1,.344-.344h6.149a.344.344,0,0,1,.344.344ZM16.5-6.187a.688.688,0,0,1-.687.688h-5.5a.688.688,0,0,1-.687-.687V-7.562a.681.681,0,0,1,.649-.687h5.5a.687.687,0,0,1,.688.688Zm5.5,0a.688.688,0,0,1-.687.688h-2.75a.69.69,0,0,1-.687-.687V-7.562a.687.687,0,0,1,.688-.687h2.75A.69.69,0,0,1,22-7.562Zm0-5.5a.69.69,0,0,1-.687.688H17.188a.688.688,0,0,1-.687-.687v-2.75a.687.687,0,0,1,.688-.687h4.125a.69.69,0,0,1,.688.688Z" transform="translate(0 17.875)" fill="currentColor"/>
                  </svg>
                </span>
                <template v-if="canEditBillingDetails === false">Billing details</template>
                <template v-else>Edit billing details</template>
              </a>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 owner"
                 v-if="invoices && invoices.length > 0"
                 :class="[{ 'active  color-1-100': activeSection === 'billingInvoices' }]">
              <a href="#" @click.prevent="goToPageSection('billingInvoices')">
                <span class="anchor-item-icon color-1-40">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="22" viewBox="0 0 16.5 22">
                    <path id="invoices" d="M14.25-.25v5.5h5.5Zm1.375,11H7.375V13.5h8.25Zm-2.75-5.5V-.25H5.313A2.062,2.062,0,0,0,3.25,1.813V19.688A2.063,2.063,0,0,0,5.313,21.75H17.688a2.062,2.062,0,0,0,2.063-2.062V6.625H14.289A1.382,1.382,0,0,1,12.875,5.25ZM6,2.844A.346.346,0,0,1,6.344,2.5H9.781a.346.346,0,0,1,.344.344v.688a.345.345,0,0,1-.344.344H6.344A.346.346,0,0,1,6,3.531Zm0,2.75a.346.346,0,0,1,.344-.344H9.781a.345.345,0,0,1,.344.344v.688a.345.345,0,0,1-.344.344H6.344A.346.346,0,0,1,6,6.281ZM17,18.656a.346.346,0,0,1-.344.344H13.219a.345.345,0,0,1-.344-.344v-.687a.346.346,0,0,1,.344-.344h3.438a.346.346,0,0,1,.344.344Zm0-8.594v4.125a.685.685,0,0,1-.687.688H6.688A.685.685,0,0,1,6,14.188V10.063a.685.685,0,0,1,.688-.687h9.625A.684.684,0,0,1,17,10.063Z" transform="translate(-3.25 0.25)" fill="currentColor"/>
                  </svg>
                </span>
                Documents
              </a>
            </div>
          </div>
        </div>
        <div class="content-left-section">
          <div class="content-section profile-section no-margin-top"
               v-if="currentPlan && currentPlan.plan"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'subscriptionDetails' }]"
               tabindex="-1"
               ref="subscriptionDetails">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                Plan summary
              </h3>
              <div class="edit-details-billing-group">
                <a href="#" v-on:click.prevent="initCancelSubscription()" class="edit-details edit-details-billing border-1-40 color-2-100"
                   v-if="company.billingDetailsData.disconnectedFromBilling === 0 && getUserRole === 'ca'">
                  <span class="cancel-subscription color-1-100">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                      <path id="times" fill="currentColor" d="M8-14A8,8,0,0,0,0-6,8,8,0,0,0,8,2a8,8,0,0,0,8-8A8,8,0,0,0,8-14Zm2.5,9.469a.75.75,0,0,1,0,1.061.75.75,0,0,1-1.061,0L8-4.941,6.53-3.471a.75.75,0,0,1-1.061,0,.75.75,0,0,1,0-1.061L6.939-6,5.469-7.5a.75.75,0,0,1,0-1.061.75.75,0,0,1,1.061,0L8-7.059l1.47-1.47a.75.75,0,0,1,1.061,0,.75.75,0,0,1,0,1.061L9.061-6Z" transform="translate(0 14)" />
                    </svg>
                  </span>
                  Cancel subscription
                </a>
                <a href="#" v-on:click.prevent="openEditPayment()" class="edit-details edit-details-pay-now border-1-40 color-2-100"
                   v-if="invoicesToBePaid && canEditPayment === false && getUserRole === 'ca'">
                  <span class="pay-now color-1-100">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14">
                      <path id="credit-card" d="M16-13H2a2,2,0,0,0-2,2V-1A2,2,0,0,0,2,1H16a2,2,0,0,0,2-2V-11A2,2,0,0,0,16-13ZM1.972-5.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-1ZM5-1.25A.251.251,0,0,1,4.75-1H2.25A.25.25,0,0,1,2-1.25v-.5A.25.25,0,0,1,2.25-2h2.5A.25.25,0,0,1,5-1.75Zm6,0a.25.25,0,0,1-.25.25H6.25A.251.251,0,0,1,6-1.25v-.5A.25.25,0,0,1,6.25-2h4.472a.25.25,0,0,1,.25.25ZM12-4.5a.5.5,0,0,1-.5.5h-4A.5.5,0,0,1,7-4.5v-1A.5.5,0,0,1,7.472-6h4a.5.5,0,0,1,.5.5Zm4,0a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5Zm0-4a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5Z" transform="translate(0 13)" fill="currentColor"/>
                    </svg>
                  </span>
                  Pay now
                </a>
              </div>
              <div class="subscription__plan-data__wrapper">
                <div class="subscription__plan-data blue-section">
                  <p class="subscription__plan-data--text">
                    <template v-if="0 === parseInt(currentPlan.price)">
                      You're on the free <strong>{{ currentPlan.plan.name }} plan for {{ currentPlanSize }} organisations</strong>
                    </template>
                    <template v-else>
                      You pay <strong>£{{ planPrice }} <template v-if="vatDisplay">(including VAT)</template> / {{ currentPlanSubscriptionPaymentPeriod }}</strong> via <template v-if="profile && profile.company && profile.company.payment_method === 0">Credit Card</template><template v-else>Bank Transfer</template> for your <strong>{{ currentPlan.plan.name }} plan for {{ currentPlanSize }} organisations</strong>.
                    </template>
                  </p>
                  <div class="subscription__plan-data--details">
                    <div class="subscription__plan-data--details__column">
                      <div class="subscription__plan-data--details__column--label">Billing period</div>
                      <div class="subscription__plan-data--details__column--text">{{ currentPlanPaymentPeriod }}</div>
                    </div>
                    <div class="subscription__plan-data--details__column">
                      <div class="subscription__plan-data--details__column--label">Commitment period</div>
                      <div class="subscription__plan-data--details__column--text">{{ currentPlanCommitment }}</div>
                    </div>
                    <div class="subscription__plan-data--details__column">
                      <div class="subscription__plan-data--details__column--label">Active until</div>
                      <div class="subscription__plan-data--details__column--text">{{ commitmentExpiryDate }}</div>
                    </div>
                    <div class="subscription__plan-data--details__column">
                      <div class="subscription__plan-data--details__column--label">Renewal date</div>
                      <div class="subscription__plan-data--details__column--text">{{ nextPaymentDate }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="invoicesToBePaid && canEditPayment === true">
                <div class="complete-profile__content--form__head">
                  <div>
                    <h2>Card details</h2>
                    <p>
                      Please fill in the fields below with the required details. Learn more about each section by tapping the ‘i’ icon next to the field label.<br />
                    </p>
                  </div>
                  <div class="card-payment-area--info">
                    <div class="card-payment-area--info__secure-icon">
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="shield-check" class="svg-inline--fa fa-shield-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill="currentColor" d="M466.5 83.71l-192-80c-4.875-2.031-13.16-3.703-18.44-3.703c-5.312 0-13.55 1.672-18.46 3.703L45.61 83.71C27.7 91.1 16 108.6 16 127.1C16 385.2 205.2 512 255.9 512C307.1 512 496 383.8 496 127.1C496 108.6 484.3 91.1 466.5 83.71zM352 200c0 5.531-1.901 11.09-5.781 15.62l-96 112C243.5 335.5 234.6 335.1 232 335.1c-6.344 0-12.47-2.531-16.97-7.031l-48-48C162.3 276.3 160 270.1 160 263.1c0-12.79 10.3-24 24-24c6.141 0 12.28 2.344 16.97 7.031l29.69 29.69l79.13-92.34c4.759-5.532 11.48-8.362 18.24-8.362C346.4 176 352 192.6 352 200z"></path>
                      </svg>
                    </div>
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="credit-card-front" class="svg-inline--fa fa-credit-card-front" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                      <path fill="currentColor" d="M512 32h-448c-35.35 0-64 28.65-64 64v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96C576 60.65 547.3 32 512 32zM63.1 272c0-8.838 7.164-16 16-16h96c8.836 0 16 7.162 16 16v32c0 8.836-7.164 16-16 16h-96c-8.836 0-16-7.164-16-16V272zM160 408C160 412.4 156.4 416 152 416h-80C67.58 416 64 412.4 64 408l0-16c0-4.42 3.582-8 8-8h80c4.418 0 8 3.58 8 8L160 408zM352 408c0 4.418-3.582 8-8 8h-144C195.6 416 192 412.4 192 408l0-16c0-4.42 3.582-8 8-8h143.1c4.418 0 8 3.58 8 8L352 408zM384 304c0 8.836-7.164 16-16 16h-128c-8.836 0-16-7.164-16-16v-32c0-8.838 7.164-16 15.1-16h128c8.836 0 16 7.162 16 16L384 304zM512 304c0 8.836-7.164 16-16 16h-64C423.2 320 416 312.8 416 304l0-32c0-8.838 7.164-16 16-16H496C504.8 256 512 263.2 512 272V304zM512 176C512 184.8 504.8 192 496 192h-96c-8.836 0-16-7.164-16-16v-64c0-8.838 7.164-16 16-16H496C504.8 96 512 103.2 512 112V176z"></path>
                    </svg>
                    <strong>SECURE</strong> PAY
                  </div>
                </div>
                <div class="card-payment-area">
                  <div id="stripePaymentIframe"
                       v-on:mousedown="paymentIframeActioned()">
                    <iframe :src="stripeBillingUrl"></iframe>
                  </div>
                  <div class="card-payment-area--error" v-if="payment.error">
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-xmark" class="svg-inline--fa fa-circle-xmark fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                      <path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"></path>
                    </svg>
                    <div id="card-error">{{ payment.error }}</div>
                  </div>
                </div>
              </template>
            </article>
            <div class="clearfix"></div>
          </div>
          <div class="content-section profile-section"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'billingContact' || canEditBillingContact, 'no-margin-top': !(currentPlan && currentPlan.plan) }]"
               tabindex="-1"
               ref="billingContact">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditBillingContact === false">Billing contact</template>
                <template v-else>Edit billing contact</template>
              </h3>
              <a href="#" v-on:click.prevent="openEditBillingContact()" class="edit-details edit-details-custom border-1-40 color-2-100"
                 v-if="canEditBillingContact === false && (getUserRole === 'gm' || getUserRole === 'ca' || getUserRole === 'ta')">
                  <span class="edit-icon color-1-100">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                      <g id="XMLID_1_">
                        <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                          c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                        <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                          L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                          l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                      </g>
                    </svg>
                  </span>
                Edit
              </a>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="billing-first-name" class="form-label color-2-63">First name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('First name'), 'is-locked': !canEditBillingContact, 'not-empty': company.billingContactData.firstName !== '' }]"
                         :disabled="canEditBillingContact === false"
                         v-model="company.billingContactData.firstName"
                         data-lpignore="true"
                         id="billing-first-name"
                         name="First name">
                  <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
                </div>
                <div class="form-element">
                  <label for="billing-phone" class="form-label color-2-63">Phone number</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Phone number'), 'is-locked': !canEditBillingContact, 'not-empty': company.billingContactData.phone !== '' }]"
                         :disabled="canEditBillingContact === false"
                         v-model="company.billingContactData.phone"
                         data-lpignore="true"
                         id="billing-phone"
                         name="Phone number">
                  <span class="form-field-error" v-if="this.errors.has('Phone number')">{{ this.errors.first('Phone number') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="billing-first-name" class="form-label color-2-63">Last name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Last name'), 'is-locked': !canEditBillingContact, 'not-empty': company.billingContactData.lastName !== '' }]"
                         :disabled="canEditBillingContact === false"
                         v-model="company.billingContactData.lastName"
                         data-lpignore="true"
                         id="billing-last-name"
                         name="Last name">
                  <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-user-email" class="form-label color-2-63">Email</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Email'), 'is-locked': !canEditBillingContact, 'not-empty': company.billingContactData.email !== '' }]"
                         :disabled="canEditBillingContact === false"
                         data-lpignore="true"
                         id="new-user-email"
                         v-validate="'email'"
                         name="Email"
                         v-model="company.billingContactData.email"/>
                  <span class="form-field-error" v-if="this.errors.has('Email')">{{ this.errors.first('Email') }}</span>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="update-data update-data__details" v-if="canEditBillingContact && (getUserRole === 'gm' || getUserRole === 'ca' || getUserRole === 'ta')">
                <a href="#" v-on:click.prevent="closeEditBillingContact()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</a>
                <a href="#" v-on:click.prevent="updateCompanyBillingContactData()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</a>
              </div>
            </article>
          </div>
          <div class="content-section profile-section"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'billingDetails' || canEditBillingDetails }]"
               tabindex="-1"
               ref="billingDetails">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditBillingDetails === false">Billing details</template>
                <template v-else>Edit billing details</template>
              </h3>
              <a href="#" v-on:click.prevent="openEditBillingDetails()" class="edit-details edit-details-custom border-1-40 color-2-100"
                 v-if="canEditBillingDetails === false && (getUserRole === 'gm' || getUserRole === 'ca' || getUserRole === 'ta')">
                  <span class="edit-icon color-1-100">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                      <g id="XMLID_1_">
                        <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                          c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                        <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                          L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                          l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                      </g>
                    </svg>
                  </span>
                Edit
              </a>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="complete-profile-billing-organisation" class="form-label color-2-63">Organisation name*</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Billing organisation name'), 'is-locked': !canEditBillingDetails, 'not-empty': company.billingDetailsData.organisationName !== '' }]"
                         :disabled="canEditBillingDetails === false"
                         data-lpignore="true"
                         v-model="company.billingDetailsData.organisationName"
                         id="complete-profile-billing-organisation"
                         v-validate.persist="'required'"
                         name="Billing organisation name">
                  <span class="form-field-error" v-if="this.errors.has('Billing organisation name')">{{ this.errors.first('Billing organisation name') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="complete-profile-billing-organisation-type" class="form-label color-2-63">Organisation type*</label>
                  <v-select class="form-control form-control__select background-1-10-child border-1-10-child background-2-10-locked border-2-10-locked"
                            :class="[{ 'has-error': errors.has('Billing organisation type'), 'is-locked': !canEditBillingDetails, 'not-empty': company.billingDetailsData.organisationType !== null }]"
                            :disabled="canEditBillingDetails === false"
                            :searchable="true"
                            :clearable="false"
                            v-model="company.billingDetailsData.organisationType"
                            :options="companyOrganizationTypes"
                            data-lpignore="true"
                            v-validate.persist="'required'"
                            name="Organisation type"
                            id="complete-profile-billing-organisation-type"/>
                  <span class="form-field-error" v-if="this.errors.has('Billing organisation type')">{{ this.errors.first('Billing organisation type') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="complete-profile-billing-vat" class="form-label color-2-63">VAT</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('VAT'), 'is-locked': !canEditBillingDetails, 'not-empty': company.billingDetailsData.organisationVat !== '' }]"
                         :disabled="canEditBillingDetails === false"
                         data-lpignore="true"
                         v-model="company.billingDetailsData.organisationVat"
                         id="complete-profile-billing-vat"
                         name="VAT">
                  <span class="form-field-error" v-if="this.errors.has('VAT')">{{ this.errors.first('VAT') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="complete-profile-billing-address-county" class="form-label color-2-63">County/State</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('County/State'), 'is-locked': !canEditBillingDetails, 'not-empty': company.billingDetailsData.addressCounty !== '' }]"
                         :disabled="canEditBillingDetails === false"
                         data-lpignore="true"
                         v-model="company.billingDetailsData.addressCounty"
                         id="complete-profile-billing-address-county"
                         name="County/State">
                  <span class="form-field-error" v-if="this.errors.has('County/State')">{{ this.errors.first('County/State') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="complete-profile-billing-address-street" class="form-label color-2-63">Street address*</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Street address'), 'is-locked': !canEditBillingDetails, 'not-empty': company.billingDetailsData.addressStreet !== '' }]"
                         :disabled="canEditBillingDetails === false"
                         data-lpignore="true"
                         v-model="company.billingDetailsData.addressStreet"
                         id="complete-profile-billing-address-street"
                         v-validate.persist="'required'"
                         name="Street address">
                  <span class="form-field-error" v-if="this.errors.has('Street address')">{{ this.errors.first('Street address') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="complete-profile-billing-address-postal-code" class="form-label color-2-63">Postcode*</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Postcode'), 'is-locked': !canEditBillingDetails, 'not-empty': company.billingDetailsData.addressPostalCode !== '' }]"
                         :disabled="canEditBillingDetails === false"
                         data-lpignore="true"
                         v-model="company.billingDetailsData.addressPostalCode"
                         id="complete-profile-billing-address-postal-code"
                         v-validate.persist="'required'"
                         name="Postcode">
                  <span class="form-field-error" v-if="this.errors.has('Postcode')">{{ this.errors.first('Postcode') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="complete-profile-billing-address-city" class="form-label color-2-63">City*</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('City'), 'is-locked': !canEditBillingDetails, 'not-empty': company.billingDetailsData.addressCity !== '' }]"
                         :disabled="canEditBillingDetails === false"
                         data-lpignore="true"
                         v-model="company.billingDetailsData.addressCity"
                         id="complete-profile-billing-address-city"
                         v-validate.persist="'required'"
                         name="City">
                  <span class="form-field-error" v-if="this.errors.has('City')">{{ this.errors.first('City') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="complete-profile-billing-address-country" class="form-label color-2-63">Country*</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Country'), 'is-locked': !canEditBillingDetails, 'not-empty': company.billingDetailsData.addressCountry !== '' }]"
                         :disabled="canEditBillingDetails === false"
                         data-lpignore="true"
                         v-model="company.billingDetailsData.addressCountry"
                         id="complete-profile-billing-address-country"
                         v-validate.persist="'required'"
                         name="Country">
                  <span class="form-field-error" v-if="this.errors.has('Country')">{{ this.errors.first('Country') }}</span>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="update-data update-data__details" v-if="canEditBillingDetails && (getUserRole === 'gm' || getUserRole === 'ca' || getUserRole === 'ta')">
                <a href="#" v-on:click.prevent="closeEditBillingDetails()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</a>
                <a href="#" v-on:click.prevent="updateCompanyBillingDetailsData()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</a>
              </div>
            </article>
          </div>
          <div class="content-section profile-section"
               v-if="invoices && invoices.length > 0"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'billingInvoices' }]"
               tabindex="-1"
               ref="billingInvoices">
            <article class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                Documents
              </h3>
              <div class="data-list-body">
                <table class="table table-data border-1-20">
                <thead class="table-head-mobile-custom background-1-40-before border-1-40">
                <tr>
                  <th class="column-created-head table-head-ceil background-1-10 border-1-20"
                      scope="col">
                    <div class="caption-head caption-head-text">
                      Document number
                    </div>
                  </th>
                  <th class="column-active-head table-head-ceil background-1-10 border-1-20"
                      scope="col">
                    <div class="caption-head caption-head-text">
                      Issue date
                    </div>
                  </th>
                  <th class="column-active-head table-head-ceil background-1-10 border-1-20"
                      scope="col">
                    <div class="caption-head caption-head-text">
                      Amount
                    </div>
                  </th>
                  <th class="column-active-head table-head-ceil background-1-10 border-1-20"
                      scope="col">
                    <div class="caption-head caption-head-text">
                      Status
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(invoice, i) in invoices" tabindex="0" @click.prevent.stop="downloadInvoice(invoice.id)">
                  <td class="created-cell cellpadding text-center border-1-20" data-title="Invoice number:">{{ invoice.columns.number ? invoice.columns.number : 'n/a' }}</td>
                  <td class="last-login-cell cellpadding text-center border-1-20" data-title="Issue date:">{{ invoice.columns.issueDate ? convertDate(invoice.columns.issueDate.text, '.') : 'n/a' }}</td>
                  <td class="created-cell cellpadding text-center border-1-20" data-title="Billed:">{{ invoice.columns.billed ? ('£' + invoice.columns.billed) : 'n/a' }}</td>
                  <td class="status-cell cellpadding text-center border-1-20" data-title="Status:" :class="[{expired: invoice.columns.expired}]">{{ invoice.columns.status ? invoice.columns.status : 'n/a' }}</td>
                </tr>
                </tbody>
              </table>
              </div>
            </article>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END:.profile -->
</template>

<script>
  import api from '@/api'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'billing-profile',
    props: {
      embeddedCompanyId: {
        type: Number,
        required: false
      },
      embedded: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data () {
      return {
        infMsgTitle: '',
        infMsgDescription: '',
        infMsgClass: '',
        messageDisplay: false,
        canEditBillingContact: false,
        canEditBillingDetails: false,
        canEditPayment: false,
        company: {
          billingContactData: {
            firstName: '',
            lastName: '',
            phone: '',
            email: ''
          },
          billingDetailsData: {
            organisationName: '',
            type: '',
            vat: '',
            county: '',
            street: '',
            postalCode: '',
            city: '',
            country: '',
            disconnectedFromBilling: null
          }
        },
        initialData: {
          billingContactData: {
            firstName: '',
            lastName: '',
            phone: '',
            email: ''
          },
          billingDetailsData: {
            organisationName: '',
            organisationType: '',
            organisationVat: '',
            addressCounty: '',
            addressStreet: '',
            addressPostalCode: '',
            addressCity: '',
            addressCountry: '',
            disconnectedFromBilling: null
          }
        },
        canLeave: false,
        isChanged: false,
        companyId: null,
        activeSection: 'subscriptionDetails',
        currentPlan: null,
        invoices: [],
        invoicesToBePaid: null,
        payment: {
          error: null
        }
      }
    },
    computed: {
      ...mapGetters([
        'profile',
        'getUserRole',
        'getUserCompany',
        'companyOrganizationTypes',
        'companySizes',
        'getConfData'
      ]),
      vatDisplay () {
        return this.subscriptionDetails && this.subscriptionDetails.billingDetailsData &&
          this.subscriptionDetails.billingDetailsData.addressCountry &&
          this.subscriptionDetails.billingDetailsData.addressCountry.toLowerCase() === 'united kingdom'
      },
      planPrice () {
        // if (!this.currentPlan.price) {
        //   return ''
        // }
        // if (!this.vatDisplay) {
        //   return this.currentPlan.price
        // }
        // return parseFloat(this.currentPlan.price) + (parseFloat(this.currentPlan.price) * 0.2)
        return this.currentPlan.price || ''
      },
      currentPlanSubscriptionPaymentPeriod () {
        if (!this.currentPlan) {
          return ''
        }
        let text = ''
        if (this.currentPlan.paymentPeriodUnit === 0) {
          if (this.currentPlan.paymentPeriodValue === 1) {
            text = '1 month'
          } else {
            text = `${this.currentPlan.paymentPeriodValue} months`
          }
        } else if (this.currentPlan.paymentPeriodUnit === 1) {
          if (this.currentPlan.paymentPeriodValue === 1) {
            text = '1 year'
          } else {
            text = `${this.currentPlan.paymentPeriodValue} years`
          }
        }
        return text
      },
      currentPlanSize () {
        if (!this.currentPlan) {
          return ''
        }
        const size = this.companySizes.find(s => s.min === this.currentPlan.minSize)
        if (!size) {
          return ''
        }
        return size.label
      },
      currentPlanPaymentPeriod () {
        if (!this.currentPlan) {
          return ''
        }
        if (this.currentPlan.paymentPeriodUnit === 0) {
          if (this.currentPlan.paymentPeriodValue === 1) {
            return 'Monthly'
          } else {
            return `Every ${this.currentPlan.paymentPeriodValue} months`
          }
        } else if (this.currentPlan.paymentPeriodUnit === 1) {
          if (this.currentPlan.paymentPeriodValue === 1) {
            return 'Yearly'
          } else {
            return `Every ${this.currentPlan.paymentPeriodValue} years`
          }
        }
      },
      currentPlanCommitment () {
        if (!this.currentPlan) {
          return ''
        }
        let text
        if (this.currentPlan.commitment === 1) {
          text = '1 Year'
        } else if (this.currentPlan.commitment === 3) {
          text = '3 Years'
        } else {
          text = 'No commitment'
        }
        return text
      },
      nextPaymentDate () {
        if (this.profile && this.profile.company.suspended && !this.profile.company.subscription_end) {
          return 'n/a'
        }
        if (!this.currentPlan || !this.currentPlan.expiryOn) {
          return 'n/a'
        }
        let expiryOn = new Date(this.currentPlan.expiryOn)
        if (isNaN(expiryOn) || isNaN(Date.parse(expiryOn))) {
          return 'n/a'
        }
        let dd = String(expiryOn.getDate()).padStart(2, '0')
        let mm = String(expiryOn.getMonth() + 1).padStart(2, '0')
        let yyyy = expiryOn.getFullYear()
        return dd + '.' + mm + '.' + yyyy
      },
      commitmentExpiryDate () {
        if (this.profile && this.profile.company.suspended && !this.profile.company.subscription_end) {
          return 'n/a'
        }
        if (!this.currentPlan || !this.currentPlan.commitmentExpiryOn) {
          return 'n/a'
        }
        let commitmentExpiryOn = new Date(this.currentPlan.commitmentExpiryOn)
        if (isNaN(commitmentExpiryOn) || isNaN(Date.parse(commitmentExpiryOn))) {
          return 'n/a'
        }
        let dd = String(commitmentExpiryOn.getDate()).padStart(2, '0')
        let mm = String(commitmentExpiryOn.getMonth() + 1).padStart(2, '0')
        let yyyy = commitmentExpiryOn.getFullYear()
        return dd + '.' + mm + '.' + yyyy
      },
      stripeBillingUrl () {
        if (!this.invoicesToBePaid || (Array.isArray(this.invoicesToBePaid) && this.invoicesToBePaid.length === 0)) {
          return null
        }
        return `${api.billingServerURL}/stripe-payment/${this.companyId}?check=0dce2bbbc190a8efb559d6dc892f677c&renew=true&invoice=${this.invoicesToBePaid[0]}`
      }
    },
    methods: {
      ...mapActions([
        'clearConfAction',
        'setInformationMsg',
        'authLogout',
        'getCompanyOrganizationTypes',
        'getCompanySizes',
        'initConfAction'
      ]),
      getCompanyVariation () {
        if (!this.companyId) {
          return
        }
        this.$http.post(`${api.URLS.variation}/company/${this.companyId}`, {}, api.headersAuthSettings).then((res) => {
          if (!res.body.hasOwnProperty('success')) {
            this.currentPlan = res.body
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      openEditBillingContact: function () {
        this.canEditBillingContact = true
      },
      openEditBillingDetails: function () {
        this.canEditBillingDetails = true
      },
      openEditPayment: function () {
        this.canEditPayment = true
      },
      closeEditBillingContact: function () {
        this.company.billingContactData = this.initialData.billingContactData
        this.canEditBillingContact = false
        this.errors.clear()
      },
      closeEditBillingDetails: function () {
        this.company.billingDetailsData = this.initialData.billingDetailsData
        this.canEditBillingDetails = false
        this.errors.clear()
      },
      closeEditPayment: function () {
        this.canEditPayment = false
        this.payment.error = null
      },
      closeMsg: function () {
        if (this.errors) {
          this.errors.clear()
        }
      },
      fieldChange () {
        this.isChanged = true
      },
      getCompanyData () {
        this.$http.put(api.URLS.companyCreate, {id: this.companyId}, api.headersAuthSettings).then((res) => {
          let subscriptionDetails = this.company
          // company billing contact
          subscriptionDetails.billingContactData.firstName = res.body.billing_first_name
          subscriptionDetails.billingContactData.lastName = res.body.billing_last_name
          subscriptionDetails.billingContactData.phone = res.body.billing_phone
          subscriptionDetails.billingContactData.email = res.body.billing_email
          // company billing details
          subscriptionDetails.billingDetailsData.organisationName = res.body.billing_company_name
          subscriptionDetails.billingDetailsData.organisationType = res.body.billing_company_type
          subscriptionDetails.billingDetailsData.organisationVat = res.body.billing_company_vat
          subscriptionDetails.billingDetailsData.addressCounty = res.body.billing_address_county
          subscriptionDetails.billingDetailsData.addressStreet = res.body.billing_address_street
          subscriptionDetails.billingDetailsData.addressPostalCode = res.body.billing_address_postal_code
          subscriptionDetails.billingDetailsData.addressCity = res.body.billing_address_city
          subscriptionDetails.billingDetailsData.addressCountry = res.body.billing_address_country
          subscriptionDetails.billingDetailsData.disconnectedFromBilling = res.body.disconnected_from_billing
          this.subscriptionDetails = subscriptionDetails
          // set initial data
          this.initialData = subscriptionDetails

          document.title = 'Billing details | Clear Assured'
          this.$store.commit('setUserDimensions')
          if (window._paq) {
            window._paq.push(['setCustomUrl', location.pathname])
            window._paq.push(['setDocumentTitle', document.title])
            window._paq.push(['trackPageView'])
          }
          // if (window.ga) {
          //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
          //   window.ga('send', 'pageview', {
          //     'page': location.pathname,
          //     'location': location.href,
          //     'title': document.title
          //   })
          // }
        }).catch((err) => {
          if (err.status === 404) {
            let props = this.$router.resolve({
              name: 'error'
            })
            this.$router.push(props.href)
          }
          if (err.status === 401) {
            this.authLogout()
          }
        })
      },
      updateCompanyBillingContactData () {
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let billing = {
          id: this.companyId,
          billingFirstName: this.company.billingContactData.firstName,
          billingLastName: this.company.billingContactData.lastName,
          billingPhoneNumber: this.company.billingContactData.phone,
          billingEmail: this.company.billingContactData.email
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, billing, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.name + ' organisation billing contact was successfully updated.'
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
              this.canEditBillingContact = !this.canEditBillingContact
            })
            .catch((err) => {
              this.disableAPI = false
              this.infMsgTitle = 'Error. We were not able to update this company billing contact because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
            })
      },
      updateCompanyBillingDetailsData () {
        if (this.disableAPI) return
        this.$validator.validateAll()
        if (this.errors.items.length) return
        let billing = {
          id: this.companyId,
          billingCompanyName: this.company.billingDetailsData.organisationName,
          billingCompanyType: this.company.billingDetailsData.organisationType,
          billingCompanyVat: this.company.billingDetailsData.organisationVat,
          billingAddressCounty: this.company.billingDetailsData.addressCounty,
          billingAddressStreet: this.company.billingDetailsData.addressStreet,
          billingAddressPostalCode: this.company.billingDetailsData.addressPostalCode,
          billingAddressCity: this.company.billingDetailsData.addressCity,
          billingAddressCountry: this.company.billingDetailsData.addressCountry
        }
        this.disableAPI = true
        this.$http.put(api.URLS.companyCreate, billing, api.headersAuthSettings)
            .then((res) => {
              this.disableAPI = false
              this.infMsgTitle = res.body.name + ' organisation billing details was successfully updated.'
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'success'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
              this.canEditBillingDetails = !this.canEditBillingDetails
            })
            .catch((err) => {
              this.disableAPI = false
              this.infMsgTitle = 'Error. We were not able to update this company billing details because '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
              this.infMsgClass = 'error'
              this.setInformationMsg({
                isShown: true,
                title: this.infMsgTitle,
                text: this.infMsgDescription,
                className: this.infMsgClass
              })
              this.getCompanyData()
            })
      },
      goToPageSection (ref) {
        let element = this.$refs[ref]
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
          setTimeout(function () {
            element.focus()
          })
        }
      },
      posY (elm) {
        let test = elm
        let top = 0
        while (test !== null && test.tagName.toLowerCase() !== 'body') {
          top += test.offsetTop
          test = test.offsetParent
        }
        return top
      },
      scrollY () {
        if (window.pageYOffset) {
          return window.pageYOffset
        }
        return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
      },
      isScrolledIntoView (elem) {
        let docViewTop = this.scrollY()
        let docViewBottom = docViewTop + window.outerHeight
        let elemTop = this.posY(elem) + 300
        let elemBottom = elemTop + elem.offsetHeight
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
      },
      handleScroll () {
        let sections = this.$refs
        for (let index in sections) {
          let section = sections[index]
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index
          }
        }
      },
      convertDate (payload, separator) {
        if (!payload) return
        let date = new Date(payload)
        let fullYear = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        function toDoubleDigit (num) {
          return num.toString().length < 2 ? '0' + num : num.toString()
        }
        return toDoubleDigit(day) + separator + toDoubleDigit(month) + separator + fullYear
      },
      getInvoices () {
        let url = `${api.URLS.companyInvoice}/list`
        if (this.embedded) {
          url += `?companyId=${this.companyId}`
        }
        this.$http.get(url, api.headersAuthSettings)
          .then((res) => {
            this.invoices = res.body.items || []
            this.invoices = this.invoices.filter(invoice => invoice.columns.status !== 'Authorised')
            // this.invoices = this.invoices.map(i => {
            //   if (i.columns.status !== 'Paid' && i.columns.dueDate) {
            //     const dueDate = new Date(i.columns.dueDate.text)
            //     if (dueDate < new Date()) {
            //       i.columns.expired = true
            //     }
            //     i.columns.status = `Due on ${this.convertDate(i.columns.dueDate.text, '.')}`
            //   }
            //   return i
            // })
          })
          .catch((err) => {
            console.log(err)
          })
      },
      downloadInvoice (invoiceId) {
        let url = `${api.URLS.companyInvoice}/download/${invoiceId}`
        if (this.embedded) {
          url += `?companyId=${this.companyId}`
        }
        this.$http.get(url, api.headersAuthSettings)
          .then((res) => {
            if (res.body.file && res.body.file.data) {
              let a = document.createElement('a')
              a.href = 'data:application/pdf;base64,' + res.body.file.data
              a.download = res.body.file.name
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      initCancelSubscription: function () {
        this.confOpened = 'disconnectFromBilling'
        this.initConfAction({
          actionName: 'disconnectCompanyFromBilling'
        })
      },
      cancelSubscription () {
        let id = this.companyId
        this.disableAPI = true
        this.$http.put(`${api.URLS.companyDisconnectedFromBilling}/${id}`, {}, api.headersAuthSettings)
          .then((res) => {
            this.company.billingDetailsData.disconnectedFromBilling = true
            this.disableAPI = false
            this.getCompanyData()
          })
          .catch((err) => {
            this.disableAPI = false
            if (err.body.message) {
              this.infMsgTitle = 'Error. We were not able to cancel subscription because: ' + err.body.message
            } else {
              this.infMsgTitle = 'Error. We were not able to cancel subscription because: '
              for (let error in err.body.error.exception) {
                this.infMsgTitle += err.body.error.exception[error].message + ' '
              }
            }
            this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
            this.infMsgClass = 'error'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
          })
        this.getConfData.actionConfirmed = false
      },
      getCompanyActiveInvoice () {
        this.disableAPI = true
        this.$http.get(`${api.URLS.getCompanyActiveInvoice}`, api.headersAuthSettings)
          .then((res) => {
            this.disableAPI = false
            if (res.body && Array.isArray(res.body) && res.body.length > 0) {
              this.invoicesToBePaid = res.body
            }
          })
          .catch(() => {
            this.disableAPI = false
          })
        this.getConfData.actionConfirmed = false
      },
      paymentIframeActioned () {
        this.$validator.validateAll([
          'Terms of service'
        ]).then((success) => {
          if (!success) {
            // const termsOfService = document.getElementById('complete-profile-terms-of-service')
            // if (termsOfService) {
            //   termsOfService.scrollIntoView({
            //     behavior: 'auto',
            //     block: 'center',
            //     inline: 'center'
            //   })
            // }
          }
        })
      }
    },
    components: {},
    watch: {
      'getConfData.actionConfirmed' (value) {
        if (value) {
          if (this.confOpened === 'disconnectFromBilling') this.cancelSubscription()
          this.clearConfAction()
        }
      }
    },
    created () {
      this.companyId = !this.embedded ? this.getUserCompany : this.embeddedCompanyId
      this.getCompanyVariation()
      this.getCompanyData()
      this.getCompanyOrganizationTypes()
      this.getCompanySizes()
      this.getInvoices()
      this.getCompanyActiveInvoice()
      const myEventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
      const myEventListener = window[myEventMethod]
      const myEventMessage = myEventMethod === 'attachEvent' ? 'onmessage' : 'message'
      myEventListener(myEventMessage, (e) => {
        const iframe = document.getElementById('stripePaymentIframe')
        if (!iframe) {
          return
        }
        const isError = /^payment_process_error::/.test(e.data)
        if (e.data === 'payment_process_started') {
          iframe.classList.add('payment_process_started')
          document.body.style.overflow = 'hidden'
        } else if (e.data === 'payment_process_succeeded' || isError) {
          iframe.classList.remove('payment_process_started')
          document.body.style.overflow = ''
          if (isError) {
            this.payment.error = e.data.replace('payment_process_error::', '')
          } else {
            this.setInformationMsg({
              isShown: true,
              title: 'Subscription successfully paid',
              text: 'Subscription successfully paid text',
              className: 'success'
            })
            this.closeEditPayment()
            this.invoicesToBePaid = null
            this.getCompanyActiveInvoice()
            this.getCompanyVariation()
          }
        }
      }, false)
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style lang="scss">
  .caption-head-text {
    -webkit-justify-content: center;
    justify-content: center;
  }
  .status-cell.expired {
    color: #CD2242;
  }
  @media screen and (max-width: 930px) {
    .data-list-body table thead.table-head-mobile-custom {
      display: none !important;
    }
    .data-list-body table tbody tr td {
      padding-left: 150px !important;
      &:after {
        width: 150px !important;
      }
    }
  }
</style>
<style src='@/assets/scss/components/profile.scss' lang='scss' />
<style src='@/assets/scss/components/table.scss' lang='scss' ></style>



// WEBPACK FOOTER //
// BillingProfile.vue?61d266f0